import React, {
  createContext, FC, useContext, useReducer,
} from 'react';
import { models } from '@ynomia/core';
import { ActionFromPayloadMap } from '../config/types';
import DigitalTwinReducer from '../reducers/digitalTwin';

export type DigitalTwinStateType = {
  isTwinReady: boolean
  isTwinLoading: boolean
  lastSelectedLayer: string | undefined
  loadingPercentage: number
  models: Array<models.ModelResponse> | undefined
};

export type DigitalTwinActionPayloadMap = {
  SET_IS_TWIN_READY: boolean;
  SET_IS_TWIN_LOADING: boolean;
  SET_LAST_SELECTED_LAYER: string | undefined;
  SET_IS_LOADING_PERCENTAGE: number;
  SET_MODELS: DigitalTwinStateType['models'];
};

export type DigitalTwinAction = ActionFromPayloadMap<DigitalTwinActionPayloadMap>;

const initialState: DigitalTwinStateType = {
  isTwinReady: false,
  isTwinLoading: false,
  lastSelectedLayer: undefined,
  loadingPercentage: 0,
  models: undefined,
};

export const DigitalTwinContext = createContext({
  state: initialState,
  dispatch: (() => { }) as React.Dispatch<DigitalTwinAction>,
});

export const useDigitalTwin = (): [DigitalTwinStateType, React.Dispatch<DigitalTwinAction>] => {
  const { state, dispatch } = useContext(DigitalTwinContext);
  return [state, dispatch];
};

export const DigitalTwinProvider:FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [state, dispatch] = useReducer(DigitalTwinReducer, initialState);

  return (
    <DigitalTwinContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </DigitalTwinContext.Provider>
  );
};
